<template>
  <div class="popover">
    <div>
      <span>{{$t('popover')}}</span>
      <span class="case-link">
        <br />
        <span class="icon">&#xe92d;</span>
        <a @click.stop="leadToCase(caseName)">{{caseName}}</a>
      </span>
    </div>
    <div class="arrow">
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    caseName: {
      type: String,
      default: ""
    }
  },
  methods: {
    leadToCase(caseName) {
      this.$emit("linkToCase", caseName);
    }
  }
};
</script>

<style lang="scss" scoped>
.popover {
  position: absolute;
  font-size: 12px;
  line-height: 20px;
  text-align: left;
  color: $dark-purple;
  bottom: -56px;
  font-weight: 300;
  padding: 4px;
  right: -175px;
  width: 210px;
  // height: 46px;
  background: $base-color;
  box-shadow: 0px 1px 7px -2px rgba(13, 36, 60, 1);
  z-index: 50;
  &::after {
    @include after;
    width: 100%;
    height: 100%;
    left: 0px;
    top: -20px;
  }
  & .case-link {
    & > .icon {
      color: $light-purple;
    }
    a {
      color: $dark-purple;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
        font-weight: 400;
      }
    }
  }
  & > .arrow {
    width: 14px;
    height: 14px;
    // background-color: $base-color;
    position: absolute;
    top: -10px;
    left: 10px;
    overflow: hidden;
    & > span {
      position: relative;
      transform: rotate(45deg);
      transform-origin: center;
      display: inline-block;
      background-color: $base-color;
      width: 10px;
      height: 10px;
      border-radius: 2px;
      left: 2px;
      bottom: -4px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/popover.vue